import { render, staticRenderFns } from "./InstantPrint.vue?vue&type=template&id=c4efa990&"
import script from "./InstantPrint.vue?vue&type=script&lang=js&"
export * from "./InstantPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports